export const orderDetailPhotos = {
    0: [1, 2, 3, 4, 5, 6, 7, 8],
    1: [0, 1, 5, 6, 7, 8, 10, 11, 13, 14, 16, 17, 18, 19],
    2: [1, 2, 3, 4, 5, 6, 7, 8],
    3: [],
    4: [],
    5: [4, 5, 6, 7],
    6: [5, 6, 7, 8, 9, 10, 12, 13],
    7: [0, 1, 2, 3, 4, 5],
    8: [1, 2],
    9: [],
    10: [2, 3, 4, 5],
    11: [4, 5, 6, 7, 8, 9, 10, 11],
}

export const orderDetailPhotos2 = {
    0: [2, 3, 4, 5, 7, 8, 10, 11, 13, 14, 16, 17, 18, 19, 22, 23],
    1: [2,3],
    2: []
}

export const orderDetailPhotos3 = {
    0: [2, 3, 4, 5],
    1: [1, 2, 4, 5, 7, 8],
    2: [2, 3]
}
/* Primero en json, después en collaborators si agregas uno, después en photos (incluyendo las fotos en el github) y por último en esta página si tiene un orden distinto. */

